import logger from '../../services/logging/logging-service';
import { init as initPlayers } from '../video-player/init-players';
import { VIDEO_PLAYER_STATUS, VIDEO_PLAYER_PLAYERTYPE } from '../video-player/constants';
import { isMobile } from '../../utils/device-utils';
import { getLabel } from '../../labels/labelling-service';

import {
  CAROUSEL_INLINE_CLASSNAME,
  destroyDisclaimer,
  initPreactCarousel,
  movePreactCarousel,
  redirectToFirstVideoUrl,
  renderDisclaimer,
} from './helpers';

const PLAYER_CLASSNAME = '.j-player';
const DISCLAIMER_TEXT_PREROLL = getLabel('video.article.hero.disclaimer.preroll');
const DISCLAIMER_TEXT_REDIRECT = getLabel('video.article.hero.disclaimer.redirect');

const handleHeroPlayerEvents = (heroPlayer) => {
  if (!heroPlayer) {
    return;
  }

  heroPlayer.on(VIDEO_PLAYER_STATUS.AD_PLAY, async () => {
    renderDisclaimer(DISCLAIMER_TEXT_PREROLL);
    logger.info('Video Article', 'INITIATE DISCLAIMER');
  });

  heroPlayer.on(VIDEO_PLAYER_STATUS.PLAY, async () => {
    if (isMobile()) {
      logger.info('Video Article', 'INITIATE CAROUSEL MOBILE');
      initPreactCarousel();
    }
    logger.info('Video Article', 'DESTROY DISCLAIMER');
    destroyDisclaimer();
  });

  heroPlayer.on(VIDEO_PLAYER_STATUS.COMPLETE, async () => {
    logger.info('Video Article', 'REDIRECT TO NEW PAGE');
    redirectToFirstVideoUrl();
  });

  heroPlayer.on(VIDEO_PLAYER_STATUS.ERROR, async () => {
    if (isMobile()) {
      logger.info('Video Article', 'INITIATE CAROUSEL ON ERROR');
      initPreactCarousel();
    }
  });

  heroPlayer.on(VIDEO_PLAYER_STATUS.SETUP_ERROR, async () => {
    if (isMobile()) {
      logger.info('Video Article', 'INITIATE CAROUSEL ON SETUP ERROR');
      initPreactCarousel();
    }
  });

  heroPlayer.on(VIDEO_PLAYER_STATUS.GENERIC_ERROR, async () => {
    if (isMobile()) {
      logger.info('Video Article', 'INITIATE CAROUSEL MOBILE');
      initPreactCarousel();
    }
    logger.info('Video Article', 'DESTROY DISCLAIMER GENERIC ERROR');
    destroyDisclaimer();
  });

  heroPlayer.on(VIDEO_PLAYER_STATUS.THIRD_QUARTILE, async () => {
    logger.info('Video Article', 'RENDER DISCLAIMER REDIRECT');
    const $carouselInline = document.querySelector(CAROUSEL_INLINE_CLASSNAME);
    if ($carouselInline) {
      renderDisclaimer(DISCLAIMER_TEXT_REDIRECT);
    }
  });
};

export const init = () => {
  logger.info('Video Article', 'INIT');
  const videosOnPage = document.querySelectorAll(PLAYER_CLASSNAME);
  const players = initPlayers(videosOnPage);

  if (isMobile()) {
    movePreactCarousel();
  } else {
    initPreactCarousel();
  }

  players?.playerConfigList?.forEach((playerConfig, index) => {
    if (playerConfig.playersetup.playertype === VIDEO_PLAYER_PLAYERTYPE.HERO) {
      handleHeroPlayerEvents(players.playerList[index]);
    }
  });
};
